export const cardLock = {
    hideInfoMessage: true,
};
